import { APP_CONFIG } from 'config/config';
import { apiFetch, apiFetchRaw } from 'lib/api';

const baseUrl = `${APP_CONFIG.apiUrl}/v1/videos`;

export function fetchVideosForTournament(tournamentId) {
    return apiFetch(`${baseUrl}/tournaments/${tournamentId}`);
}
export function getVideosForTournament(tournamentId, callback) {
    fetchVideosForTournament(tournamentId).then(callback);
}

// VideoList.jsx reads the `X-Total-Count` response header for pagination, so
// this returns the raw Response via apiFetchRaw rather than parsed JSON.
export function getVideos(opts) {
    const { page, unmatched, sourceId, pageSize } = opts;
    const source = sourceId ? '&sourceId=' + sourceId : '';
    const pSize = pageSize ? '&pageSize=' + pageSize : '';

    return apiFetchRaw(baseUrl + '?page=' + page + pSize + '&unmatched=' + unmatched + source);
}

export function fetchVideosForTeam(req) {
    const pageSize = req.pageSize ? '?pageSize=' + req.pageSize : '';
    return apiFetch(`${baseUrl}/teams/${req.teamSlug}` + pageSize);
}
export function getVideosForTeam(req, callback) {
    fetchVideosForTeam(req).then(callback);
}

export function fetchVideoSources() {
    return apiFetch(baseUrl + '/sources');
}
export function getSources(callback) {
    fetchVideoSources().then(callback);
}

export function fetchVideosByPlayerSlug(opts) {
    const { slug, pageSize } = opts;
    const pSize = pageSize ? '?pageSize=' + pageSize : '';
    return apiFetch(baseUrl + '/players/' + slug + pSize);
}
export function getVideosByPlayerSlug(opts, callback) {
    fetchVideosByPlayerSlug(opts).then(callback);
}

export function fetchVideo(videoId) {
    return apiFetch(baseUrl + '/' + videoId);
}
export function getVideo(videoId, callback) {
    fetchVideo(videoId).then(callback);
}

export function fetchVideoComments(videoId) {
    return apiFetch(baseUrl + '/' + videoId + '/comments');
}
export function getVideoComments(videoId, callback) {
    fetchVideoComments(videoId).then(callback);
}

// VideoTitleAndComments.jsx only console.logs / ignores the resolved value,
// so these keep returning the raw Response (via apiFetchRaw) just as the
// original callback-style versions did, rather than parsing JSON nothing
// downstream reads.
export function postVideoComment(body) {
    return apiFetchRaw(`${APP_CONFIG.apiUrl}/v1/comments`, {
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
        method: 'POST'
    });
}
export function postComment(body, callback) {
    postVideoComment(body).then(callback);
}

export function putVideoRating(videoId, body) {
    return apiFetchRaw(`${baseUrl}/${videoId}/rating`, {
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body),
        method: 'PUT'
    });
}
export function putRatingOnVideo(videoId, body, callback) {
    putVideoRating(videoId, body).then(callback);
}

export function fetchLikedVideosForUser() {
    return apiFetch(`${baseUrl}/liked`);
}
export function getLikedVideosForUser(callback) {
    fetchLikedVideosForUser().then(callback);
}

export function matchVideoToGame(videoId, gameId) {
    return apiFetchRaw(`${baseUrl}/${videoId}/match-game`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ gameId })
    });
}
